// extracted by mini-css-extract-plugin
module.exports = {"hashtag":"ReflectionText_hashtag__uFX_O","body":"ReflectionText_body__0Igdy"};